import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function InfoSection({
  title,
  text,
  extraTitle,
  imgSrc,
  buttonText,
  reverse,
  bgColor,
  textColor,
  onButtonClick,
  heroSpacing = { title: "40px", subtitle: "30px", tagline: "35px" }
}) {
  const esHero = title === "Bienvenidos a IMAGINA Soluciones IT";
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: esHero
          ? "linear-gradient(135deg, #FFA500 0%, #FFE0B2 100%)"
          : bgColor || "white",
        padding: esHero ? "100px 0 60px" : "60px 0"
      }}
    >
      <Container>
        {esHero ? (
          <div style={{ textAlign: "center" }}>
            <h1
              style={{
                fontSize: "60px",
                fontWeight: "900",
                color: "#FFA500",
                marginBottom: heroSpacing.title
              }}
            >
              {title}
            </h1>

            <h2
              style={{
                fontSize: "34px",
                fontWeight: "700",
                marginBottom: heroSpacing.subtitle,
                color: "#222"
              }}
            >
              Lo que imaginás, <span style={{ color: "#FFA500" }}>lo volvemos tecnología</span>.
            </h2>

            <h3
              style={{
                fontSize: "26px",
                fontWeight: "600",
                color: "#333",
                marginBottom: heroSpacing.tagline
              }}
            >
              Porque lo tuyo merece ser real.
            </h3>

            {buttonText && (
              <button
                style={{
                  padding: "12px 24px",
                  backgroundColor: "#FFC107",
                  border: "none",
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "8px",
                  cursor: "pointer"
                }}
                onClick={onButtonClick}
              >
                {buttonText}
              </button>
            )}
          </div>
        ) : (
          <Row className={`align-items-center ${reverse ? "flex-row-reverse" : ""}`}>
            <Col md={6} style={{ paddingBottom: "30px" }}>
              {title && (
                <h3
                  style={{
                    color: "#FFA500",
                    fontWeight: "bold",
                    marginBottom: "20px",
                    fontSize: "30px"
                  }}
                >
                  {title}
                </h3>
              )}

              <p
                style={{
                  fontSize: "22px",
                  color: textColor || "#000",
                  lineHeight: "1.7",
                  marginBottom: "25px"
                }}
              >
                {text}
              </p>

              {buttonText && (
                <Button
                  variant="warning"
                  size="lg"
                  onClick={onButtonClick}
                  style={{ fontWeight: "bold" }}
                >
                  {buttonText}
                </Button>
              )}
            </Col>

            <Col md={6} className="text-center">
              {typeof imgSrc === "string" ? (
                <img
                  src={imgSrc}
                  alt="Imagen de sección"
                  style={{
                    width: "100%",
                    maxWidth: "380px",
                    borderRadius: "15px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
                  }}
                />
              ) : (
                imgSrc
              )}
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default InfoSection;
